var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-6a)", stroke: "#303030", strokeWidth: "1.5" },
      React.createElement("path", { d: "M1 26H5C6.10457 26 7 26.8954 7 28V36C7 37.1046 6.10457 38 5 38H1M8 35.5L19.4719 38.4499C23.3311 39.4423 27.4266 38.8583 30.8546 36.8269L38.0059 32.5891C38.6221 32.2239 39 31.5608 39 30.8445V30.8445C39 29.4514 37.6278 28.4732 36.3109 28.9273L25.9983 32.4834C25.0331 32.8162 23.9794 32.7831 23.0371 32.3904L19.5629 30.9429C18.9193 30.6747 18.5 30.0458 18.5 29.3485V29.1565C18.5 28.4768 18.9626 27.8844 19.622 27.7195L23.2579 26.8105C23.9879 26.628 24.5 25.9721 24.5 25.2197V25.2197C24.5 24.2835 23.7174 23.5373 22.7822 23.5818L14.2871 23.9863C14.099 23.9953 13.9166 24.0536 13.7582 24.1554L7 28.5", strokeLinecap: "round" }),
      React.createElement("path", { d: "M25 32.5L31.2755 25.7763C31.7169 25.3033 32.3936 25.1312 33.0074 25.3358V25.3358C34.0228 25.6743 34.4541 26.8735 33.8868 27.7811L32.5 30", strokeLinecap: "round" }),
      React.createElement("rect", { x: "7", y: "1", width: "32", height: "18", rx: "2" }),
      React.createElement("path", { d: "M32.8333 4H13.1667C12.6144 4 12.1667 4.44772 12.1667 5C12.1667 5.55228 11.719 6 11.1667 6H11C10.4477 6 10 6.44772 10 7V13C10 13.5523 10.4477 14 11 14H11.1667C11.719 14 12.1667 14.4477 12.1667 15C12.1667 15.5523 12.6144 16 13.1667 16H32.8333C33.3856 16 33.8333 15.5523 33.8333 15C33.8333 14.4477 34.281 14 34.8333 14H35C35.5523 14 36 13.5523 36 13V7C36 6.44772 35.5523 6 35 6H34.8333C34.281 6 33.8333 5.55228 33.8333 5C33.8333 4.44772 33.3856 4 32.8333 4Z", strokeLinecap: "round" }),
      React.createElement("circle", { cx: "23", cy: "10", r: "3" }),
      React.createElement("circle", { cx: "31", cy: "10", r: "2" }),
      React.createElement("circle", { cx: "15", cy: "10", r: "2" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-6a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H40V40H0z" })
      )
    )
  );
});